import { render, staticRenderFns } from "./-info.vue?vue&type=template&id=18bdb95e&scoped=true&"
import script from "./-info.vue?vue&type=script&lang=js&"
export * from "./-info.vue?vue&type=script&lang=js&"
import style0 from "./-info.vue?vue&type=style&index=0&id=18bdb95e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bdb95e",
  null
  
)

export default component.exports